import { StyleSheet } from 'react-native';
import { DynamicStyleSheet } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  alert: {
    maxWidth: 416,
    backgroundColor: theme.colors.alertBG,
    ...Platform.select({
      ios: {
        width: 272,
        borderRadius: 18,
      },
      default: {
        minWidth: 272,
        borderRadius: 12,
        marginHorizontal: 32,
        ...theme.shadows.xl,
      },
    }),
  },
  content: {
    ...Platform.select({
      ios: {
        paddingVertical: 19,
        paddingHorizontal: 16,
      },
      default: {
        paddingVertical: 24,
        paddingHorizontal: 24,
      },
    }),
  },
  actionsHorizontal: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  actionsVertical: {
    flexDirection: 'column',
  },
  textIOS: {
    textAlign: 'center',
  },
  // All except iOS
  description: {
    color: theme.colors.textSecondary,
  },
  actionIOS: {
    height: 44,
    flexGrow: 1,
    flexShrink: 0,
    paddingHorizontal: 12,
    justifyContent: 'center',
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: theme.colors.separator,
  },
  actionsDefault: {
    paddingHorizontal: 24,
    paddingBottom: 12,
  },
  actionText: {
    color: theme.colors.alertActionText,
    ...Platform.select({
      ios: {
        textAlign: 'center',
      },
      default: {
        textAlign: 'right',
      },
    }),
  },
  actionCancel: {
    fontWeight: '500',
  },
  actionDestructive: {
    color: theme.colors.alertDestructiveActionText,
  },
  vhr: {
    width: StyleSheet.hairlineWidth,
    backgroundColor: theme.colors.separator,
  },
}));
